export default __webpack_public_path__ + "static/media/uppperbanner.c45f4318f8fd1714e8f61e36dffbae5a.svg";